import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/app/Layout";
import Pagination, { usePagination } from "@/components/app/Pagination";

export default function SuperAdminAudit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit-logs?limit=1000").then(r => setLogs(r.data.items || r.data)); }, []);
  const { page, setPage, totalPages, paged, total, pageSize } = usePagination(logs, 20);
  return (<>
    <PageHeader title="Log Aktivitas (Global)" subtitle="Riwayat aksi seluruh user di semua workspace."/>
    <div className="p-4 md:p-8">
      <div className="card-flat overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="sa-audit-table">
            <thead><tr className="bg-slate-50 border-b text-left text-[11px] uppercase text-slate-500">
              <th className="p-3">Waktu</th><th className="p-3">User</th><th className="p-3">Peran</th>
              <th className="p-3">Workspace</th><th className="p-3">Aksi</th><th className="p-3">Entity</th><th className="p-3">Detail</th>
            </tr></thead>
            <tbody>
              {paged.length===0 && <tr><td colSpan="7" className="text-center py-10 text-slate-400">Belum ada aktivitas.</td></tr>}
              {paged.map(l => (<tr key={l.id} className="border-b hover:bg-slate-50">
                <td className="p-3 text-[12px] font-mono">{l.at?.slice(0,19).replace("T"," ")}</td>
                <td className="p-3">{l.user_email}</td>
                <td className="p-3"><span className="text-[11px] px-2 py-0.5 brand-soft brand-text rounded-sm">{l.user_role}</span></td>
                <td className="p-3 text-[11px] font-mono text-slate-500">{l.workspace_id || "—"}</td>
                <td className="p-3 text-[12px]">{l.action}</td>
                <td className="p-3 text-[12px]">{l.entity}</td>
                <td className="p-3 text-[12px] text-slate-500">{l.detail}</td>
              </tr>))}
            </tbody>
          </table>
        </div>
        <Pagination page={page} setPage={setPage} totalPages={totalPages} total={total} pageSize={pageSize} testid="sa-audit-pagination"/>
      </div>
    </div>
  </>);
}
